import { Box, Collapse, Grid, Typography } from "@mui/material"
import { Underline } from "../../../components/underline"
import { useState } from "react"
import { FaMinus, FaPlus } from "react-icons/fa6"
import { Constants, Format } from "../../../utils"

const questions: {
    question: string,
    response: JSX.Element | string
}[] = [
        {
            question: "Como funciona a empresa GYROO?",
            response: "Somos uma fintech especializada em oferecer crédito exclusivo para empresas. Nosso serviço permite que você obtenha crédito imediato, parcelado em 24 diárias. Além disso, ao longo do tempo, seu limite de crédito aumenta mês a mês. Com apenas um ano de relacionamento, seu limite pode chegar a até R$ 20 mil, ajudando sua empresa a crescer com mais facilidade e agilidade."
        },
        {
            question: "O que precisa para solicitar o crédito GYROO?",
            response:
                <>
                    <Typography>Para solicitar o crédito na GYROO, você precisa ter alguns documentos e informações em mãos. Aqui está o que é necessário:</Typography>
                    <ul>
                        <li>CNPJ ativo da sua empresa</li>
                        <li>CNPJ com SCORE maior que 100 e sem dívidas no SERASA</li>
                        <li>CPF do empresário com SCORE maior que 300 e sem dívidas no SERASA</li>
                        <li>Comprovante de residência do empresário </li>
                        <li>RG ou CNH do empresário</li>
                        <li>Whatsapp do empresário</li>
                    </ul>
                </>
        },
        {
            question: "Como funciona o crédito GYROO?",
            response: <>
                <Typography>Que ótimo que você quer entender como funciona o crédito GYROO. Aqui está um passo a passo bem amigável para você:</Typography>
                <ul>
                    <li>Você solicita e simula o primeiro crédito;</li>
                    <li>Preenche o cadastro com os dados da sua empresa e os seus;</li>
                    <li>Nós analisamos sua solicitação e verificamos seu perfil;</li>
                    <li>Se aprovado, solicitamos os seus documentos e disponibilizamos o contrato para assinatura digital;</li>
                    <li>O valor solicitado é creditado na sua conta em apenas 1 minuto;</li>
                    <li>A dívida é parcelada em 24 diárias, que devem ser pagas todos os dias (exceto domingos e feriados)</li>
                    <li>Ao acessar o aplicativo, você consegue ver o contrato assinado, acompanhar as 24 diárias, gerar o código PIX para pagamento de cada uma, além de ter atendimento exclusivo, solicitar um novo crédito e ainda indicar um amigo para ganhar R$ 20; </li>
                </ul>
            </>
        },
        {
            question: "Qual é o crédito que a GYROO disponibiliza?",
            response:
                <>
                    <Typography mb={2}>
                        A GYROO disponibiliza créditos que variam de {Format.currency(Constants.creditEvolution[0])} até {Format.currencyWritten(Constants.creditEvolution[Constants.creditEvolution.length - 1])}. Geralmente, começamos oferecendo um crédito inicial de {Format.currency(Constants.creditEvolution[0])}. Conforme você paga as diárias do primeiro mês, seu limite de crédito aumenta para o próximo mês. Assim, a escala de crédito vai crescendo mês a mês, de acordo com o seu pagamento. Veja abaixo a evolução dessa escala:
                    </Typography>

                    <Box
                        component="table"
                        sx={{
                            width: "100%",
                            borderCollapse: "collapse",
                            "& td": {
                                padding: "0.8rem",
                                border: "1px solid #ddd",
                                textAlign: "center"
                            },
                            "& tr:nth-of-type(odd)": {
                                backgroundColor: "#f5f5f594",
                            },
                        }}
                    >
                        <tbody>
                            {Constants.creditEvolution.map((item, index) => (
                                <tr>
                                    <td>{index + 1}º MÊS</td>
                                    <td>{Format.currency(item)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Box>
                </>

        },
        {
            question: "Por quais motivos posso ter o crédito GYROO negado?",
            response:
                <>
                    <Typography>Existem alguns motivos que podem levar à negação do crédito GYROO, como por exemplo:</Typography>
                    <ul>
                        <li>CNPJ ou CPF com SCORE baixo ou com dívidas no SERASA;</li>
                        <li>Dados cadastrais desatualizados, como whatsapp e endereço;</li>
                        <li>Comprovante de residência desatualizado</li>
                    </ul>

                    <Typography>Se algum desses itens estiverem pendentes ou desatualizados, pode ser que seu pedido de crédito não seja aprovado. </Typography>
                </>
        },
    ]

export const LearnMore = ({
    breakComponents,
    isMobile
}: {
    breakComponents: boolean,
    isMobile: boolean
}) => {
    const [indexExpand, setIndexExpand] = useState<number[]>([])

    return (
        <Box
            sx={{
                maxWidth: "100rem",
                width: "90%",
                background: "#4C81E61A",
                alignSelf: "center",
                borderRadius: "10px",
                padding: "2rem 1rem",
            }}
            mt={isMobile ? "-5rem" : "5rem"}

        >
            <Grid
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                mb={"2rem"}
            >
                <Underline>
                    <Typography
                        variant="h2"
                        textAlign={"center"}
                        sx={{
                            background: "linear-gradient(90deg, #1D22E6 0%, #10126C 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                        }}>Saiba mais</Typography>
                </Underline>
            </Grid>

            <Grid>
                {questions.map((item, i) => {
                    const expanded = indexExpand.includes(i)
                    return (
                        <Grid
                            padding={isMobile ? "1rem" : "2rem 3rem"}
                        >
                            <Grid
                                component={"button"}
                                bgcolor={"transparent"}
                                border={"none"}
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                gap={isMobile ? "1rem" : "2rem"}
                                sx={{
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    if (expanded) {
                                        setIndexExpand(indexExpand.filter((item) => item !== i))
                                    } else {
                                        setIndexExpand(prev => ([...prev, i]))
                                    }
                                }}
                            >
                                <Box display="flex" alignItems="center" justifyContent="center" width="30px" height="30px">
                                    {expanded ? <FaMinus style={{
                                        color: "#10126C",
                                        opacity: .6,
                                        fontSize: "25px"
                                    }} /> : <FaPlus style={{
                                        color: "#10126C",
                                        opacity: .6,
                                        fontSize: "25px"
                                    }} />}
                                </Box>
                                <Typography fontSize={isMobile ? "1.8rem" : breakComponents ? "2rem" : "3rem"} textAlign={"start"} color="#10126C" sx={{ opacity: .5 }} fontWeight={700}>
                                    {item.question}
                                </Typography>
                            </Grid>

                            <Collapse in={expanded} sx={{
                                pl: isMobile ? "0rem" : "5.5rem",
                                ...(expanded && {
                                    mt: "2rem"
                                })
                            }}>
                                {typeof item.response === "string" ? <Typography>{item.response}</Typography> : item.response}
                            </Collapse>
                        </Grid>
                    )
                })}
            </Grid>

        </Box>
    )
}